<div class="login-wrapper">
  <!-- Spinner Overlay -->
  <div class="spinner-overlay" *ngIf="isLoading$ | async">
    <div class="spinner-container">
      <mat-spinner diameter="60"></mat-spinner>
      <p class="loading-text">Logging in...</p>
    </div>
  </div>

  <!-- Bridge Login Component -->
  <bri-teammate-login></bri-teammate-login>
</div>
